// extracted by mini-css-extract-plugin
export default {"message":"Kv5VoNHK"};